// FILECONTENT_START src/common/components/GlobalMessaging/GlobalMessaging.tsx
import CloseIcon from "@mui/icons-material/Close";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import {
  Alert,
  AlertColor,
  AlertTitle,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Snackbar,
  SnackbarProps,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import I18n from "i18n-js";
import React, { Fragment } from "react";
import Button, { ButtonProps } from "../Button";
import Spacer from "../Spacer";

export const globalMessageHandler = {
  success: (
    message: string,
    title?: string,
    action?: Function,
    snackBarProps?: SnackbarProps
  ) => {
    let event = new CustomEvent("onGobalMessage", {
      detail: {
        message,
        variant: "success",
        action,
        snackBarProps,
        title,
      },
    });
    document.dispatchEvent(event);
  },
  info: (
    message: string,
    title?: string,
    action?: Function,
    snackBarProps?: SnackbarProps
  ) => {
    let event = new CustomEvent("onGobalMessage", {
      detail: {
        message,
        variant: "info",
        action,
        snackBarProps,
        title,
      },
    });
    document.dispatchEvent(event);
  },
  infoModal: (message: string, title?: string) => {
    let event = new CustomEvent("onGobalModalMessage", {
      detail: {
        message,
        variant: "info",
        title,
      },
    });
    document.dispatchEvent(event);
  },
  error: (
    message: string,
    title?: string,
    action?: Function,
    snackBarProps?: SnackbarProps
  ) => {
    let event = new CustomEvent("onGobalMessage", {
      detail: {
        message,
        variant: "error",
        action,
        snackBarProps,
        title,
      },
    });
    document.dispatchEvent(event);
  },
  warning: (message: string) => {
    let event = new CustomEvent("onGobalMessage", {
      detail: {
        message,
        variant: "warning",
      },
    });
    document.dispatchEvent(event);
  },
  warningModal: (message: string) => {
    let event = new CustomEvent("onGobalModalMessage", {
      detail: {
        message,
        variant: "warning",
      },
    });
    document.dispatchEvent(event);
  },
  confirm: (
    message: string,
    action: Function,
    onCancel?: Function,
    buttonProps?: { yes?: ButtonProps; cancel?: ButtonProps }
  ) => {
    let event = new CustomEvent("onGobalModalMessage", {
      detail: {
        message,
        variant: "confirm",
        action,
        onCancel,
        buttonProps,
      },
    });
    document.dispatchEvent(event);
  },
  fatalError: (message: string) => {
    let event = new CustomEvent("onGobalModalMessage", {
      detail: {
        message,
        variant: "error",
      },
    });
    document.dispatchEvent(event);
  },
  validateError: (message: string, errors: any) => {
    let event = new CustomEvent("onGobalModalMessage", {
      detail: {
        message,
        errors,
        variant: "error",
      },
    });
    document.dispatchEvent(event);
  },
};

type GlobalMessagingState = {
  open: boolean;
  openModal: boolean;
  message: string;
  errors?: any | null;
  variant: "success" | "info" | "warning" | "error" | "confirm"; //AlertColor;
  action?: Function | null;
  onCancel?: Function | null;
  autoHideDuration: number;
  loading: boolean;
  snackBarProps?: SnackbarProps;
  title?: string;
  buttonProps?: { yes?: ButtonProps; cancel?: ButtonProps };
};

export default class GlobalMessaging extends React.Component {
  state: GlobalMessagingState = {
    open: false,
    openModal: false,
    message: "This is a Message!",
    errors: null,
    variant: "info",
    action: null,
    onCancel: null,
    autoHideDuration: 3000,
    loading: false,
    buttonProps: {},
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleCloseModal = () => {
    this.setState({ openModal: false });
  };

  handleAccept = () => {
    this.state.action && this.state.action();
    this.setState({ openModal: false, action: null });
  };

  componentDidMount() {
    document.addEventListener("onGobalMessage", this.onGobalMessage);
    document.addEventListener("onGobalModalMessage", this.onGobalModalMessage);
  }

  componentWillUnmount() {
    document.removeEventListener("onGobalMessage", this.onGobalMessage);
    document.removeEventListener(
      "onGobalModalMessage",
      this.onGobalModalMessage
    );
  }

  onGobalMessage = (evt: any) => {
    const { detail } = evt;

    if (this.state.open || this.state.openModal) {
      this.setState({ open: false, openModal: false }, () => {
        setTimeout(() => {
          this.setState(() => ({
            open: true,
            ...detail,
            errors: null,
          }));
        }, 200);
      });
    } else {
      this.setState(() => ({
        open: true,
        ...detail,
        errors: null,
      }));
    }
  };

  onGobalModalMessage = (evt: any) => {
    const { detail } = evt;

    if (this.state.open || this.state.openModal) {
      this.setState({ open: false, openModal: false }, () => {
        setTimeout(() => {
          this.setState(() => ({
            openModal: true,
            ...detail,
            errors: detail.errors ? detail.errors : null,
          }));
        }, 200);
      });
    } else {
      this.setState(() => ({
        openModal: true,
        ...detail,
        errors: detail.errors ? detail.errors : null,
      }));
    }
  };

  getValidationErrors = () => {
    const { errors, message } = this.state;
    let errorList: Array<any> = [];
    Object.keys(errors).forEach(key => {
      const itemErrors = errors[key];
      if (Array.isArray(itemErrors)) {
        itemErrors.forEach(err => {
          if (typeof err === "object") {
            Object.keys(err).forEach(field => {
              let element = err[field];
              if (Array.isArray(element)) {
                element = element.join(", ");
              }
              errorList.push(`${key}. sor ${element}`);
            });
          } else {
            errorList.push(err);
          }
        });
      } else if (typeof itemErrors === "string") {
        errorList.push(itemErrors);
      } else {
        errorList.push(JSON.stringify(itemErrors));
      }
    });

    return (
      <div>
        {message && message !== "" && (
          <Typography variant="body1" color="red">
            {message}
          </Typography>
        )}
        {errorList.length > 0 && (
          <ul>
            {errorList.map((error, index) => {
              return (
                <li key={index}>
                  <Typography variant="body2" color="red">
                    {error}
                  </Typography>
                </li>
              );
            })}
          </ul>
        )}
      </div>
    );
  };

  render() {
    const {
      open,
      openModal,
      message,
      variant,
      autoHideDuration,
      errors,
      action,
      loading,
      onCancel,
      snackBarProps,
      title,
      buttonProps,
    } = this.state;

    let msg = null;
    if (typeof message === "object") {
      if ((message as any).props) {
        msg = message;
      } else {
        msg = JSON.stringify(message);
      }
    } else if (errors) {
      msg = this.getValidationErrors();
    } else {
      msg = message;
    }

    const severity: AlertColor = [
      "error",
      "info",
      "success",
      "warning",
    ].includes(variant)
      ? (variant as AlertColor)
      : "info";

    return (
      <Fragment>
        <Snackbar
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          open={open}
          autoHideDuration={autoHideDuration}
          onClose={this.handleClose}
          onClick={action ? () => action() : undefined}
          {...snackBarProps}
        >
          <Alert onClose={this.handleClose} severity={severity}>
            {!!title && <AlertTitle>{title}</AlertTitle>}
            {typeof message === "string" ? message : ""}
          </Alert>
        </Snackbar>
        <Dialog
          open={openModal}
          onClose={() => {
            this.handleCloseModal();
            onCancel && onCancel();
          }}
          sx={{ minWidth: 400 }}
          //fullWidth
        >
          <DialogTitle>
            <Box display="flex" alignItems="center">
              <ErrorOutlineIcon />
              <Spacer w={1} />
              <Box flexGrow={1}>{I18n.t(`App.${variant}`)}</Box>
              <Box>
                <IconButton
                  onClick={() => {
                    this.handleCloseModal();
                    onCancel && onCancel();
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </Box>
            </Box>
          </DialogTitle>
          <DialogContent>{msg}</DialogContent>
          <DialogActions>
            <Button
              title={I18n.t(
                variant === "confirm" && action ? "App.cancel" : "App.close"
              )}
              onClick={() => {
                onCancel && onCancel();
                this.handleCloseModal();
              }}
              //color={variant === "confirm" && action ? "inherit" : "primary"}
              variant="outlined"
              {...buttonProps?.cancel}
            />
            {variant === "confirm" && action && (
              <>
                <Spacer right />
                <Button
                  title={I18n.t("App.yes")}
                  loading={loading}
                  onClick={() => {
                    if (action) {
                      let promise = action();
                      if (!!promise && typeof promise.then === "function") {
                        this.setState({ loading: true });
                        promise
                          .then(() => {
                            this.setState({ loading: false });
                            this.handleCloseModal();
                          })
                          .catch((errors: any) => {
                            this.setState({ loading: false, errors: errors });
                          });
                      } else {
                        this.handleCloseModal();
                      }
                    } else {
                      this.handleCloseModal();
                    }
                  }}
                  {...buttonProps?.yes}
                />
              </>
            )}
          </DialogActions>
        </Dialog>
      </Fragment>
    );
  }
}

// FILECONTENT_END src/common/components/GlobalMessaging/GlobalMessaging.tsx
